// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fazoY8bv3DgB5lvx1hGK{align-items:center;gap:4px;display:flex}.eDBek2BzRiMornB4jgAX{color:var(--content-primary-primary);font-weight:500}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `fazoY8bv3DgB5lvx1hGK`,
	"activeNameSpan": `eDBek2BzRiMornB4jgAX`
};
export default ___CSS_LOADER_EXPORT___;
